import { isProvinceCode } from '@lib/api';
import { scopeProvince, useSession } from './session';

/** The province a province or location account is locked to: its lists, filters and the control room show only it. */
export interface ProvinceLock { code: string; name: string }

/**
 * The province a screen shows: the account's own when it is locked to one (whatever the URL says, so an old link
 * never asks for another province and gets OUT_OF_SCOPE), else the URL's `raw` value when it is a valid code ('' =
 * the whole country). `lock` is set for a locked account: its province filter becomes a static label.
 */
export function useProvinceLock(raw?: string | null): { provinceCode: string; lock: ProvinceLock | null } {
  const lock = scopeProvince(useSession().me);
  return { provinceCode: lock?.code ?? (isProvinceCode(raw) ? raw : ''), lock };
}
